// AB#2815 — one reading of "is this boolean field true?", used by every surface that shows or edits one.
//
// Entity boolean defaults are authored as STRINGS ("default": "false" — the house style in every module
// JSON), and a declared default reaches the draft as the string it was written as. `!!value` then makes
// the string "false" TRUE, so the checkbox rendered ticked and the list printed Yes, while every engine
// predicate (`data->>'enabled' = 'true'`) correctly read not-true. Three surfaces disagreeing about one
// field, and the user is the one who finds out: on dev, two delivery jobs showed Enabled = Yes and were
// never swept, because the sweep was right and the screen was wrong.
//
// The rule: a real boolean is itself; the strings "false", "0" and "" are FALSE (case-insensitively);
// "true"/"1" are true; a number is zero-is-false. Anything else keeps JavaScript's truthiness, so this
// can only ever narrow the old behaviour on the values that were lying.
export function isTruthyValue(value: unknown): boolean {
    if (typeof value === 'boolean') { return value }
    if (typeof value === 'number') { return value !== 0 }
    if (typeof value === 'string') {
        const t = value.trim().toLowerCase()
        if (t === '' || t === 'false' || t === '0') { return false }
        if (t === 'true' || t === '1') { return true }
        return true
    }
    return !!value
}
